export const getImg = (array, startIndex) => array.reduce((acc, curr, i) => {
  if (i >= startIndex && !acc && curr.banner_image_url) {
    return curr.banner_image_url;
  } else if (acc) {
    return acc;
  }

  return null;
}, null);
